import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { translator } from "../utils/i18n";
import PropTypes from "prop-types";

export default function AlertDialogView2(props) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        disableBackdropClick={true}
        maxWidth="md"
      >
        <DialogTitle className="head-dialog" id="scroll-dialog-title">
          <div className="title-dialog">
            <i className="material-icons">warning</i>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            dividers
          >
            <div
              className="pt-20"
              dangerouslySetInnerHTML={{
                __html: props.content
              }}
            />
          </DialogContentText>
          <div className="wrap-btn">
            <button className="custom-btn" onClick={handleClose}>
              {translator()._("W_COMPRIS")}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

AlertDialogView2.propTypes = {
  content: PropTypes.string
};
